/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Fluffy_Duck_WaveInputs */

const fr_hour_fluffy_duck_wave = /** @type {(inputs: Hour_Fluffy_Duck_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir tes records`)
};

/**

* @param {Hour_Fluffy_Duck_WaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hour_fluffy_duck_wave = /** @type {((inputs?: Hour_Fluffy_Duck_WaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Fluffy_Duck_WaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hour_fluffy_duck_wave(inputs)
});